/*
 *
 * Workspace actions
 *
 */

import * as constants from './constants';

export function setPluginList(plugins) {
  return {
    type: constants.SET_PLUGIN_LIST,
    plugins,
  };
}

export function setPluginVersionList(pluginId, versionList) {
  return {
    type: constants.SET_PLUGIN_VERSION_LIST,
    pluginId,
    versionList,
  };
}

export function pluginCreateRequest() {
  return {
    type: constants.PLUGIN_CREATE_REQUEST,
  };
}

export function setPluginDetails(pluginDetails) {
  return {
    type: constants.SET_PLUGIN_DETAILS,
    pluginDetails,
  };
}

export function pluginCreateSuccess(plugin) {
  return {
    type: constants.PLUGIN_CREATE_SUCCESS,
    plugin,
  };
}

export function pluginCreateError() {
  return {
    type: constants.PLUGIN_CREATE_ERROR,
  };
}

export function setPluginCollaboratorSummary(pluginId, collaborators) {
  return {
    type: constants.SET_PLUGIN_COLLABORATOR_SUMMARY,
    pluginId,
    collaborators,
  };
}
